import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ExplicitConfirmationDialog from 'common/dialog-explicit-confirmation/DialogExplicitConfirmation';
import { useDeleteTrailerMutation } from '../../trailerStatusEndpoints';

const DeleteDialog = ({ dialogOpened, onCloseDialog, trailerId }) => {
  const [deleteTrailer, { isSuccess }] = useDeleteTrailerMutation();

  const handleDelete = () => {
    deleteTrailer({ trailerId });
  };

  useEffect(() => {
    if (isSuccess) onCloseDialog(false);
  }, [isSuccess, onCloseDialog]);

  return (
    <ExplicitConfirmationDialog
      confirmationMessage="If you still want to delete the Trailer, enter the word below and click Confirm."
      confirmationValue="DELETE"
      dialogOpen={dialogOpened}
      handleCloseDialog={() => onCloseDialog(false)}
      onConfirm={() => {
        handleDelete();
      }}
      title="Delete Trailer?"
      warningList={['This will delete the entire Trailer for all locations.']}
    />
  );
};

DeleteDialog.propTypes = {
  dialogOpened: PropTypes.bool.isRequired,
  onCloseDialog: PropTypes.func.isRequired,
  trailerId: PropTypes.string.isRequired,
};

export default DeleteDialog;
